import {create} from 'zustand'
import {sampleCampaigns, categories} from 'utils/data/campaign-filters'
import {persist} from 'zustand/middleware'

const useCampaignStore = create((set) => ({
  filter: [...categories], //선택한 필터 목록
  list: [...sampleCampaigns], //전체 campaign 목록
  filteredList: [], //필터링된 campaign 목록
  searchedText: '', //텍스트를 입력후, 검색버튼을 눌렀을 경우

  setOnView: (newViewItem) => set({onView: {...newViewItem}}),
  setFilter: (newFilter) => set({filter: [...newFilter]}),
  setList: (newList) => set({list: [...newList]}),
  setFilteredList: (newFilteredList) => set({filteredList: [...newFilteredList]}),
  setSearchedText: (newText) => {
    set({filter: [...categories]})
    if (newText === '') {
      set({searchedText: ''})
    } else {
      set({searchedText: newText})
    }
  }
}))

export default useCampaignStore

//새로고침 유지용 분리
localStorage.removeItem('givu-campaign-view-store')
export const useCampaignViewStore = create(
  persist(
    (set) => ({
      onView: {},
      setOnView: (newView) => {
        set((state) => ({...state, onView: newView}))
      }
    }),
    {name: 'givu-campaign-view-store'}
  )
)
